/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IndonesiaInputs */

const en_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia`)
};

const es_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia`)
};

const fr_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonésie`)
};

const de_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesien`)
};

const ja_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インドネシア`)
};

const zh_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印度尼西亚`)
};

const ar_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إندونيسيا`)
};

const id_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia`)
};

const it_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia`)
};

const ru_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индонезия`)
};

const pt_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonésia`)
};

const ko_indonesia = /** @type {(inputs: IndonesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인도네시아`)
};

/**
* | output |
* | --- |
* | "Indonesia" |
*
* @param {IndonesiaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const indonesia = /** @type {((inputs?: IndonesiaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IndonesiaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_indonesia(inputs)
	if (locale === "es") return es_indonesia(inputs)
	if (locale === "fr") return fr_indonesia(inputs)
	if (locale === "de") return de_indonesia(inputs)
	if (locale === "ja") return ja_indonesia(inputs)
	if (locale === "zh") return zh_indonesia(inputs)
	if (locale === "ar") return ar_indonesia(inputs)
	if (locale === "id") return id_indonesia(inputs)
	if (locale === "it") return it_indonesia(inputs)
	if (locale === "ru") return ru_indonesia(inputs)
	if (locale === "pt") return pt_indonesia(inputs)
	return ko_indonesia(inputs)
});